module.exports = __webpack_public_path__ + "static/media/CICD.820933bb.md";